import request from '@/utils/request'
import store from '@/store'
import { getToken } from '@/utils/auth'

// charges页
// 获取列表
export function pageList(params) {
  return request({
    url: '/v3/manager/deviceQRLithiumData/pageList',
    method: 'post',
    data: params
  })
}
// 上传excel
export function importExcel(params, zoon) {
  var formData = new FormData()
  formData.append('file', params.raw)
  formData.append('zone', zoon)
  return request({
    url: '/v3/manager/deviceQRLithiumData/import',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}
// 获取二维码数据
export function getQrCodeData(params) {
  return request({
    url: '/v3/manager/deviceQRLithiumData/getQrCodeData?sn=' + params,
    method: 'get',
  })
}

// 编辑--提交
export function updateDeviceQrData(params) {
  return request({
    url: '/v3/manager/deviceQRLithiumData/updateDeviceQrData',
    method: 'post',
    data: params
  })
}